export const BIRTH_MONTHS = [
  { value: '01', label: 'January' },
  { value: '02', label: 'February' },
  { value: '03', label: 'March' },
  { value: '04', label: 'April' },
  { value: '05', label: 'May' },
  { value: '06', label: 'June' },
  { value: '07', label: 'July' },
  { value: '08', label: 'August' },
  { value: '09', label: 'September' },
  { value: '10', label: 'October' },
  { value: '11', label: 'November' },
  { value: '12', label: 'December' },
];

function isOptOut(value: string): boolean {
  const normalized = value.trim().toLowerCase();
  return normalized === '' || normalized === 'out' || normalized === 'opt out' || normalized === 'opt-out';
}

/** Maps a stored birth month to the dropdown value. Blank means opted out. */
export function toBirthMonthValue(stored: string): string {
  const value = (stored || '').trim().toLowerCase();
  if (isOptOut(value)) return '';

  const byLabel = BIRTH_MONTHS.findIndex((month) => month.label.toLowerCase() === value);
  if (byLabel >= 0) return BIRTH_MONTHS[byLabel].value;

  const abbrevs = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
  const byAbbrev = abbrevs.indexOf(value);
  if (byAbbrev >= 0) return BIRTH_MONTHS[byAbbrev].value;

  const monthNumber = Number(value);
  if (Number.isInteger(monthNumber) && monthNumber >= 1 && monthNumber <= 12) {
    return String(monthNumber).padStart(2, '0');
  }
  return '';
}

/** Value stored in the zip field. Blank means opted out. */
export function optionalZipValue(zip: string): string {
  if (isOptOut(zip || '')) return '';
  return (zip || '').trim();
}

/** Blank zip codes are an opt-out. */
export function formatZipOptOut(zip: string): string {
  if (isOptOut(zip || '')) return 'opt out';
  return zip.trim();
}
